module.exports = {"430105001":"芙蓉北路街道","430105002":"东风路街道","430105003":"清水塘街道","430105004":"望麓园街道","430105005":"湘雅路街道","430105006":"伍家岭街道","430105009":"新河街道","430105010":"通泰街街道","430105012":"四方坪街道","430105013":"洪山街道","430105014":"浏阳河街道","430105015":"月湖街道","430105016":"秀峰街道","430105019":"沙坪街道","430105020":"捞刀河街道","430105021":"青竹湖街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430105.json
// module id = 1931
// module chunks = 0